import { render, staticRenderFns } from "./Packet.vue?vue&type=template&id=56a9c0c8&scoped=true"
import script from "./Packet.vue?vue&type=script&lang=js"
export * from "./Packet.vue?vue&type=script&lang=js"
import style0 from "./Packet.vue?vue&type=style&index=0&id=56a9c0c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a9c0c8",
  null
  
)

export default component.exports